// src/pages/RegistrarInstructores.jsx
import axios from 'axios';
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import geografiaFunciones from '../function/geografia.Funciones';
import { generarEdades, generarGruposSanguineos, generarSexos } from '../function/listascomunes.Funciones';
import { normalizeImage } from '../utils/image';

const RegistrarInstructores = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  // Información básica del instructor
  const [documentoInstructor, setDocumentoInstructor] = useState('');
  const [tipodocumentoInstructor, setTipodocumentoInstructor] = useState('');
  const [nombre1Instructor, setNombre1Instructor] = useState('');
  const [nombre2Instructor, setNombre2Instructor] = useState('');
  const [apellido1Instructor, setApellido1Instructor] = useState('');
  const [apellido2Instructor, setApellido2Instructor] = useState('');

  // Información personal
  const [fechanacimientoInstructor, setFechanacimientoInstructor] = useState('');
  const [edadInstructor, setEdadInstructor] = useState('');
  const [sexoInstructor, setSexoInstructor] = useState('');
  const [rhInstructor, setRhInstructor] = useState('');
  const [emailInstructor, setEmailInstructor] = useState('');

  // Información de contacto
  const [telefono1Instructor, setTelefono1Instructor] = useState('');
  const [telefono2Instructor, setTelefono2Instructor] = useState('');
  const [direccionInstructor, setDireccionInstructor] = useState('');

  // Ubicación
  const [paises, setPaises] = useState([]);
  const [estados, setEstados] = useState([]);
  const [ciudades, setCiudades] = useState([]);

  const [paisInstructor, setPaisInstructor] = useState('');
  const [estadoInstructor, setEstadoInstructor] = useState('');
  const [ciudadInstructor, setCiudadInstructor] = useState('');

  const [paisSeleccionado, setPaisSeleccionado] = useState('');
  const [estadoSeleccionado, setEstadoSeleccionado] = useState('');
  const [ciudadSeleccionada, setCiudadSeleccionada] = useState('');

  // Imagen
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState('');
  const previewRef = useRef(''); // para revocar URL
  const [uploadState, setUploadState] = useState(0);
  const [loading, setLoading] = useState(false);

  const [edit, setEdit] = useState(false);

  useEffect(() => {
    setEdit(!!id);
  }, [id]);

  const handleCancelOrClean = () => {
    if (edit) {
      navigate('/instructor/listarinstructores');
    } else {
      cleanData();
    }
  };

  useEffect(() => {
    let isMounted = true;

    const fetchInstructor = async () => {
      try {
        const { data } = await axios.get(`/api/instructores/listid/${id}`);
        if (!data.ok) {
          console.error('Error: Instructor no encontrado');
          return;
        }
        if (!isMounted) return;

        const instructorData = data.message || {};
        const fechaNacimiento = instructorData.fechanacimientoInstructor
          ? new Date(instructorData.fechanacimientoInstructor).toISOString().split('T')[0]
          : '';

        setDocumentoInstructor(instructorData.documentoInstructor || '');
        setTipodocumentoInstructor(instructorData.tipodocumentoInstructor || '');
        setNombre1Instructor(instructorData.nombre1Instructor || '');
        setNombre2Instructor(instructorData.nombre2Instructor || '');
        setApellido1Instructor(instructorData.apellido1Instructor || '');
        setApellido2Instructor(instructorData.apellido2Instructor || '');
        setFechanacimientoInstructor(fechaNacimiento);
        setEdadInstructor(instructorData.edadInstructor || '');
        setSexoInstructor(instructorData.sexoInstructor || '');
        setRhInstructor(instructorData.rhInstructor || '');
        setEmailInstructor(instructorData.emailInstructor || '');
        setTelefono1Instructor(instructorData.telefono1Instructor || '');
        setTelefono2Instructor(instructorData.telefono2Instructor || '');
        setDireccionInstructor(instructorData.direccionInstructor || '');
        setPaisInstructor(instructorData.paisInstructor || '');
        setEstadoInstructor(instructorData.estadoInstructor || '');
        setCiudadInstructor(instructorData.ciudadInstructor || '');

        if (instructorData.imgInstructor) {
          setPreview(instructorData.imgInstructor);
          previewRef.current = instructorData.imgInstructor; // si es URL remota no se revoca
        }

        const paisesData = await geografiaFunciones.obtenerPaises();
        if (!isMounted) return;
        setPaises(paisesData);

        if (instructorData.paisInstructor) {
          const estadosData = await geografiaFunciones.obtenerEstadosPorPais(instructorData.paisInstructor);
          if (!isMounted) return;
          setEstados(estadosData);
        }

        if (instructorData.estadoInstructor) {
          const ciudadesData = await geografiaFunciones.obtenerCiudadesPorEstado(instructorData.estadoInstructor);
          if (!isMounted) return;
          setCiudades(ciudadesData);
        }
      } catch (error) {
        if (!isMounted) return;
        console.error('Error al obtener instructor:', error.message);
        if (error.response && !error.response.data.ok) {
          Swal.fire({
            icon: 'error',
            title: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    };

    if (id) fetchInstructor();

    return () => {
      isMounted = false;
    };
  }, [id]);

  const cleanData = () => {
    setDocumentoInstructor('');
    setTipodocumentoInstructor('');
    setNombre1Instructor('');
    setNombre2Instructor('');
    setApellido1Instructor('');
    setApellido2Instructor('');
    setFechanacimientoInstructor('');
    setEdadInstructor('');
    setSexoInstructor('');
    setRhInstructor('');
    setEmailInstructor('');
    setTelefono1Instructor('');
    setTelefono2Instructor('');
    setDireccionInstructor('');
    setPaisInstructor('');
    setEstadoInstructor('');
    setCiudadInstructor('');
    setPaisSeleccionado('');
    setEstadoSeleccionado('');
    setCiudadSeleccionada('');
    setPaises([]);
    setEstados([]);
    setCiudades([]);

    // Limpieza de imagen
    if (preview && preview.startsWith('blob:')) {
      try { URL.revokeObjectURL(preview); } catch (e) { }
    }
    setImage(null);
    setPreview('');
    previewRef.current = '';

    // Limpiar inputs auxiliares
    const fileInput = document.getElementById('fileInput');
    if (fileInput) fileInput.value = '';
    const fileNameInput = document.getElementById('fileName');
    if (fileNameInput) fileNameInput.value = '';
    const label = document.getElementById('fileLabel');
    if (label) label.textContent = 'Seleccionar Archivo';
  };

  const saveInstructor = async (formData) => {
    try {
      setLoading(true);

      await axios.post('/api/instructores/add', formData, {
        // No pongas Content-Type, axios lo gestiona con boundary
        onUploadProgress: ({ loaded, total }) => {
          const percent = parseInt((loaded * 100) / total);
          setUploadState(percent);
        },
      });

      setLoading(false);
      cleanData();

      Swal.fire({
        icon: 'success',
        title: 'El Instructor ha sido registrado con éxito',
        showConfirmButton: false,
        timer: 1500,
      }).then(() => navigate('/instructor/listarinstructores'));
    } catch (error) {
      console.error('Error en saveInstructor:', error.message);
      Swal.fire({
        icon: 'error',
        title: 'Error al registrar',
        text: error.response?.data?.message || 'Intenta de nuevo',
      });
    }
  };

  const updateInstructor = async (formData) => {
    try {
      const { data } = await axios.put(`/api/instructores/update/${id}`, formData, {
        // No pongas Content-Type aquí tampoco
      });

      // Actualiza estados clave si lo necesitas
      setFechanacimientoInstructor(formData.get('fechanacimientoInstructor'));
      setPaisInstructor(formData.get('paisInstructor'));
      setEstadoInstructor(formData.get('estadoInstructor'));
      setCiudadInstructor(formData.get('ciudadInstructor'));

      cleanData();

      Swal.fire({
        icon: 'success',
        title: data.message || 'El Instructor ha sido actualizado con éxito',
        showConfirmButton: false,
        timer: 1500,
      }).then(() => navigate('/instructor/listarinstructores'));
    } catch (error) {
      console.error('❌ Error en updateInstructor:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error en la actualización',
        text: error.response?.data?.message || 'Intenta de nuevo',
      });
    }
  };

  const actions = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    // Imagen (si existe)
    if (image) {
      formData.append('imgInstructor', image);
    }

    // Datos básicos del instructor
    const instructorData = {
      documentoInstructor,
      tipodocumentoInstructor,
      nombre1Instructor,
      nombre2Instructor: nombre2Instructor ?? '',
      apellido1Instructor,
      apellido2Instructor: apellido2Instructor ?? '',
      edadInstructor: edadInstructor ?? 0,
      sexoInstructor: sexoInstructor ?? '',
      direccionInstructor: direccionInstructor ?? '',
      telefono1Instructor,
      telefono2Instructor: telefono2Instructor ?? '',
      fechanacimientoInstructor: fechanacimientoInstructor ?? '',
      rhInstructor: rhInstructor ?? '',
      emailInstructor,
      paisInstructor: paisInstructor ?? 0,
      estadoInstructor: estadoInstructor ?? 0,
      ciudadInstructor: ciudadInstructor ?? 0,
    };

    Object.entries(instructorData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    edit ? updateInstructor(formData) : saveInstructor(formData);
  };

  const edades = generarEdades();
  const sexos = generarSexos();
  const gruposSanguineos = generarGruposSanguineos();

  useEffect(() => {
    const cargarPaises = async () => {
      try {
        setPaises([]);
        const paisesData = await geografiaFunciones.obtenerPaises();
        const paisesUnicos = paisesData.filter(
          (pais, index, self) => index === self.findIndex((p) => p.idPais === pais.idPais)
        );
        setPaises(paisesUnicos);
      } catch (error) {
        console.error('Error al cargar países:', error);
      }
    };
    cargarPaises();
  }, []);

  const handlePaisChange = async (paisId) => {
    try {
      setPaisSeleccionado(paisId);
      setPaisInstructor(paisId);
      setEstados([]);
      setCiudades([]);
      setEstadoSeleccionado('');
      setCiudadSeleccionada('');

      if (paisId) {
        const estadosData = await geografiaFunciones.obtenerEstadosPorPais(paisId);
        const estadosUnicos = estadosData.filter(
          (estado, index, self) => index === self.findIndex((e) => e.idEstado === estado.idEstado)
        );
        setEstados(estadosUnicos);
      }
    } catch (error) {
      console.error('Error al cambiar el país:', error);
    }
  };

  const handleEstadoChange = async (estadoId) => {
    try {
      setEstadoSeleccionado(estadoId);
      setEstadoInstructor(estadoId);
      setCiudades([]);
      setCiudadSeleccionada('');

      if (estadoId) {
        const ciudadesData = await geografiaFunciones.obtenerCiudadesPorEstado(estadoId);
        const ciudadesUnicas = ciudadesData.filter(
          (ciudad, index, self) => index === self.findIndex((c) => c.idCiudad === ciudad.idCiudad)
        );
        setCiudades(ciudadesUnicas);
      }
    } catch (error) {
      console.error('Error al cambiar el estado:', error);
    }
  };

  const handleCiudadChange = (ciudadId) => {
    setCiudadSeleccionada(ciudadId);
    setCiudadInstructor(ciudadId);
  };

  // NUEVO: Manejo completo de archivo desde cámara (HEIC → JPEG + compresión)
  const handleFileChange = async (e) => {
    try {
      if (!e.target.files || !e.target.files[0]) return;
      const file = e.target.files[0];

      // Aceptamos extensiones e incluso si el tipo es image/*
      const isValidName =
        /\.(jpeg|jpg|png|svg|heic|heif)$/i.test(file.name || '');
      const isValidType = /image\//.test(file.type || '');
      if (!isValidName && !isValidType) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo no válido',
          text: 'Usa .jpg, .jpeg, .png (o HEIC en iPhone)',
        });
        e.target.value = '';
        return;
      }

      // Normaliza (convierte, comprime, corrige orientación)
      const processed = await normalizeImage(file);

      // Limpia URL previa si era blob
      if (preview && preview.startsWith('blob:')) {
        try { URL.revokeObjectURL(preview); } catch (err) { }
      }

      setImage(processed);
      const blobUrl = URL.createObjectURL(processed);
      setPreview(blobUrl);
      previewRef.current = blobUrl;

      // Actualiza UI auxiliar
      const label = document.getElementById('fileLabel');
      const fileNameInput = document.getElementById('fileName');
      if (fileNameInput) fileNameInput.value = processed.name || 'imagen.jpg';
      if (label) label.textContent = 'Cambiar Imagen';
    } catch (err) {
      console.error('Error procesando imagen:', err);
      Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo procesar la imagen.' });
    }
  };

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
      <div className="container-fluid mt-3">
        <h1>Registrar Instructores</h1>
      </div>

      <div className="mb-5">
        <form onSubmit={actions}>
          <div className="container">
            {/* Fila que contiene dos columnas */}
            <div className="row d-flex justify-content-between">
              {/* Columna izquierda: datos del docente */}
              <div className="col-md-9">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="nombre1" className="form-label  mt-3 mb-2 ">Nombre 1</label>
                    <input
                      type="text"
                      className="form-control"
                      id="nombre1"
                      placeholder="Ingrese Nombre1"
                      value={nombre1Instructor}
                      onChange={(e) => setNombre1Instructor(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="nombre2" className="form-label  mt-3 mb-2 ">Nombre 2</label>
                    <input
                      type="text"
                      className="form-control"
                      id="nombre2"
                      placeholder="Ingrese Nombre2"
                      value={nombre2Instructor}
                      onChange={(e) => setNombre2Instructor(e.target.value)}
                    />
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="apellido1" className="form-label  mt-3 mb-2">Apellido 1</label>
                    <input
                      type="text"
                      className="form-control"
                      id="apellido1"
                      placeholder="Ingrese Apellido1"
                      value={apellido1Instructor}
                      onChange={(e) => setApellido1Instructor(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="apellido2" className="form-label  mt-3 mb-2">Apellido 2</label>
                    <input
                      type="text"
                      className="form-control"
                      id="apellido2"
                      placeholder="Ingrese Apellido2"
                      value={apellido2Instructor}
                      onChange={(e) => setApellido2Instructor(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="tipoDocumento" className="form-label mt-3 mb-2">Tipo de Documento</label>
                    <select
                      className="form-control"
                      id="tipoDocumento"
                      value={tipodocumentoInstructor}
                      onChange={(e) => setTipodocumentoInstructor(e.target.value)}
                      required
                    >
                      <option value="">Seleccione un tipo</option>
                      <option value="CC">Cédula de Ciudadanía</option>
                      <option value="TI">Tarjeta de Identidad</option>
                      <option value="CE">Cédula de Extranjería</option>
                      <option value="PAS">Pasaporte</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="numeroDocumento" className="form-label mt-3 mb-2">Número de Documento</label>
                    <input
                      type="text"
                      className="form-control"
                      id="numeroDocumento"
                      placeholder="Ingrese documento"
                      value={documentoInstructor}
                      onChange={(e) => setDocumentoInstructor(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="direccion" className="form-label  mt-3 mb-2">Dirección</label>
                    <input
                      type="text"
                      className="form-control"
                      id="direccion"
                      placeholder="Ingrese su dirección"
                      value={direccionInstructor}
                      onChange={(e) => setDireccionInstructor(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="telefono1" className="form-label  mt-3 mb-2">Teléfono 1</label>
                    <input
                      type="tel"
                      className="form-control"
                      id="telefono1"
                      placeholder="Ingrese teléfono1"
                      value={telefono1Instructor}
                      onChange={(e) => setTelefono1Instructor(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="telefono2" className="form-label  mt-3 mb-2">Teléfono 2</label>
                    <input
                      type="tel"
                      className="form-control"
                      id="telefono2"
                      placeholder="Ingrese teléfono2"
                      value={telefono2Instructor}
                      onChange={(e) => setTelefono2Instructor(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="email" className="form-label  mt-3 mb-2">Correo Electrónico</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Ingrese E-Mail"
                      value={emailInstructor}
                      onChange={(e) => setEmailInstructor(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="fechanacimiento" className="form-label  mt-3 mb-2 ">Fecha de Nacimiento</label>
                    <input
                      type="date"
                      className="form-control"
                      id="fechanacimiento"
                      value={fechanacimientoInstructor}
                      onChange={(e) => setFechanacimientoInstructor(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="edad" className="form-label  mt-3 mb-2 ">Edad</label>
                    <select
                      className="form-select"
                      value={edadInstructor}
                      onChange={(e) => setEdadInstructor(e.target.value)}
                    >
                      <option value="">Seleccione edad</option>
                      {edades.map((edad) => (
                        <option key={edad} value={edad}>
                          {edad}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="sexo" className="form-label  mt-3 mb-2 ">Sexo</label>
                    <select
                      id="sexo"
                      className="form-control"
                      value={sexoInstructor}
                      onChange={(e) => setSexoInstructor(e.target.value)}
                      required
                    >
                      <option value="">Seleccione un sexo</option>
                      {sexos.map((sexo, index) => (
                        <option key={index} value={sexo.valor}>
                          {sexo.etiqueta}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="rh" className="form-label  mt-3 mb-2 ">RH</label>
                    <select
                      id="grupoSanguineo"
                      className="form-control"
                      value={rhInstructor}
                      onChange={(e) => setRhInstructor(e.target.value)}
                      required
                    >
                      <option value="">Seleccione un RH</option>
                      {gruposSanguineos.map((grupo) => (
                        <option key={grupo} value={grupo}>
                          {grupo}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="pais" className="form-label  mt-3 mb-2 ">País</label>
                    <select
                      className="form-control"
                      onChange={(e) => handlePaisChange(e.target.value)}
                      value={paisSeleccionado || paisInstructor || ''}
                    >
                      <option value="">Seleccione un país</option>
                      {Array.isArray(paises) && paises.length > 0 ? (
                        paises.map((pais) => (
                          <option key={pais.idPais} value={pais.idPais}>
                            {pais.nombrePais}
                          </option>
                        ))
                      ) : (
                        <option value="" disabled>Cargando países...</option>
                      )}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="estado" className="form-label  mt-3 mb-2 ">Estado</label>
                    <select
                      className="form-control"
                      onChange={(e) => handleEstadoChange(e.target.value)}
                      value={estadoSeleccionado || estadoInstructor || ''}
                      disabled={!paisSeleccionado}
                    >
                      <option value="">Seleccione un estado</option>
                      {Array.isArray(estados) && estados.length > 0 ? (
                        estados.map((estado) => (
                          <option key={estado.idEstado} value={estado.idEstado}>
                            {estado.nombreEstado}
                          </option>
                        ))
                      ) : (
                        <option value="" disabled>
                          {paisSeleccionado ? 'Cargando estados...' : 'Seleccione un país primero'}
                        </option>
                      )}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="ciudad" className="form-label  mt-3 mb-2 ">Ciudad</label>
                    <select
                      className="form-control"
                      onChange={(e) => handleCiudadChange(e.target.value)}
                      value={ciudadSeleccionada || ciudadInstructor || ''}
                      disabled={!estadoSeleccionado}
                    >
                      <option value="">Seleccione una ciudad</option>
                      {Array.isArray(ciudades) && ciudades.length > 0 ? (
                        ciudades.map((ciudad) => (
                          <option key={ciudad.idCiudad} value={ciudad.idCiudad}>
                            {ciudad.nombreCiudad}
                          </option>
                        ))
                      ) : (
                        <option value="" disabled>
                          {estadoSeleccionado ? 'Cargando ciudades...' : 'Seleccione un estado primero'}
                        </option>
                      )}
                    </select>
                  </div>
                </div>
              </div>

              {/* Columna derecha: foto */}
              <div className="col-md-3 text-end">
                <label htmlFor="foto" className="form-label text-center w-100 mt-3 mb-2">
                  Foto
                </label>

                <div className="col-md-12">
                  {/* Vista previa */}
                  <div
                    className="card-img-top bg-light d-flex align-items-center justify-content-center"
                    style={{
                      width: '100%',
                      height: '280px',
                      border: '1px dashed #ccc',
                      overflow: 'hidden',
                    }}
                  >
                    {preview !== '' ? (
                      <img
                        src={preview}
                        className="img-fluid"
                        alt="Vista previa"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    ) : (
                      <span className="text-muted">Vista previa</span>
                    )}
                  </div>

                  {/* Selector de archivo */}
                  <div className="d-grid gap-2 mt-3">
                    {/* Input de archivo para cámara/galería */}
                    <input
                      type="file"
                      id="fileInput"
                      name="imgInstructor"
                      className="d-none"
                      accept="image/*"
                      capture="environment"
                      onChange={handleFileChange}
                    />

                    {/* Campo para nombre del archivo */}
                    <input
                      type="text"
                      id="fileName"
                      className="form-control text-muted"
                      placeholder="Ningún archivo seleccionado"
                      readOnly
                    />

                    {/* Botón que abre el input */}
                    <label
                      id="fileLabel"
                      htmlFor="fileInput"
                      className="btn btn-primary btn-sm w-100 mt-2"
                    >
                      Seleccionar Archivo
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* Botón de envío */}
            <div className="col-12 mt-4 mb-5">
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <button type="submit" className="btn btn-success w-100">
                    {edit ? 'Actualizar' : 'Enviar'}
                  </button>
                </div>
                <div className="col-12 col-md-6">
                  <button
                    type="button"
                    className={`btn w-100 ${edit ? 'btn-danger' : 'btn-secondary'}`}
                    onClick={handleCancelOrClean}
                  >
                    {edit ? 'Cancelar' : 'Limpiar'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      {/* Barra de progreso */}
      <div>
        {loading && (
          <div className="progress">
            <div
              className="progress-bar bg-primary"
              role="progressbar"
              style={{ width: `${uploadState}%` }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RegistrarInstructores;
